export default "__VITE_ASSET__Cp$0LSWo__"